import React from "react";
import { Label, Col, Row } from 'reactstrap'
import NumberFormat from 'react-number-format';

function SimulationParameterComponent(props) {
    let param = props.param;
    if(param == null)
        return <React.Fragment></React.Fragment>
    let classNames = ["form-control"];
    let rowClassNames = ["form-group"];
    let hidden = false;
    const invalid = !!props.invalid;
    if (invalid) classNames.push("param-invalid");
    let decimals = param.f ? param.f : props.viewDecimals ? 2 : 0;
    if (param.rol) {
        return (<React.Fragment></React.Fragment>);
    }
    rowClassNames.push(hidden ? "fadeOut" : "fadeIn");

    return (
        <Row key={"rowparam" + param.name} className={rowClassNames.join(' ')}>
            <Label htmlFor={param.name} md={9} className="simulationParameterLabel">
                {param.description}&nbsp;
                {param.tip ? (<i data-tip={param.tip} className="fa-info-circle-alt">i</i>) : <></>}
            </Label>
            <Col key={"OutputParamaneter" + param.name} md={3}>
                <NumberFormat
                    thousandSeparator={param.t}
                    prefix={param.p}
                    suffix={param.s}
                    model={"." + param.name}
                    id={param.name}
                    name={param.name}
                    isAllowed={param.rule}
                    autoComplete="off"
                    disabled={param.rol === 'output'}
                    className={classNames.join(' ')}
                    style={{maxWidth: "120px"}}
                    aria-invalid={invalid ? "true" : "false"}
                    onFocus={() => {
                        if (props.touchValue) props.touchValue(param.name);
                    }}
                    onValueChange={(values) => {
                        if (props.onFocusResults) props.onFocusResults();
                        // eslint-disable-next-line
                        const { _ , value } = values;
                        props.setParam(param.name, value)
                    }}
                    value={props.value}
                />
            </Col>
        </Row>
    );
}
export default SimulationParameterComponent;